import React from "react";
import { Button, Container, Flex, Heading, Spinner, Text } from "theme-ui";
import { BackButton } from "components/BackButton";
import { ActionDrawer } from "components/ActionDrawer";
import { LabelWithBalance } from "components/LabelWithBalance";
import { SummaryTable } from "components/SummaryTable";
import { humanFriendlyNumber } from "utils/number";
import { useRecoilState } from "recoil";
import { completeRequestLoading } from "../state";
import { NETWORK_COST } from "config";
import { fromWei } from "web3-utils";
import { useRequestParams } from "hooks/useRequestParams";
import { WalletGlobal } from "hooks/useWallet";

interface IProps {
  onBackClick: () => void;
  onConfirmClick: () => void;
}

export const ConfirmCompleteRequest: React.FC<IProps> = ({
  onBackClick,
  onConfirmClick,
}) => {
  const { amount: amountWei, currency, data } = useRequestParams();
  const { gasCurrency } = WalletGlobal.useContainer();
  const [loading] = useRecoilState(completeRequestLoading);

  if (!currency || !amountWei || !data) {
    return <Heading as="h2">Invalid request</Heading>;
  }

  const amount = fromWei(amountWei); // TODO: Assumes wei
  const totalCost = Number(amount) + Number(NETWORK_COST);

  let button = (
    <Button onClick={onConfirmClick} variant="primary">
      Complete Request
    </Button>
  );

  return (
    <Container>
      <BackButton onClick={onBackClick} />
      <br />
      <Text sx={{ mb: 1 }} variant="subtitle">
        Transaction Summary
      </Text>
      <br />
      <Text sx={{ mb: 4 }} variant="regularGray">
        Please review the transaction before continuing
      </Text>
      <br />
      <SummaryTable
        title="Summary"
        lineItems={[
          {
            label: "CompleteRequest Amount",
            value: `${humanFriendlyNumber(amount)} ${currency}`,
          },
          {
            label: "Est. Network Fee",
            value: `${humanFriendlyNumber(NETWORK_COST)} ${gasCurrency}`,
          },
        ]}
        totalItem={{
          label: "Est. Total",
          value:
            currency === gasCurrency
              ? `${humanFriendlyNumber(
                  Number(amount) + Number(NETWORK_COST)
                )} ${gasCurrency}`
              : `${humanFriendlyNumber(
                  Number(amount)
                )} ${currency} + ${humanFriendlyNumber(
                  NETWORK_COST
                )} ${gasCurrency}`,
        }}
      />

      <ActionDrawer>
        {loading ? (
          <Flex sx={{ justifyContent: "flex-end" }}>
            <Spinner />
          </Flex>
        ) : (
          <Flex sx={{ justifyContent: "space-between" }}>
            <LabelWithBalance
              label="Total"
              amount={totalCost.toString()}
              currency={currency}
            />
            {button}
          </Flex>
        )}
      </ActionDrawer>
    </Container>
  );
};
